var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"px-4 py-2 bg-gray-300 text-gray-500 font-semibold rounded hover:bg-gray-500 hover:text-gray-100 mr-4",on:{"click":function($event){return _vm.$router.back()}}},[_vm._t("default",[_vm._v(" Cancel ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }